module.exports = __webpack_public_path__ + "img/calligraphy-work-icon8.adb18d41.jpg";